import styled from '@emotion/styled'
import { Container, Typography } from '@mui/material'
import { WarrantyData } from "api/delek"
import EmptyResults from "common/EmptyResults"

const Styled = {
  WarrantyExtension: styled.div`
    padding: 25px 17px;
    background-color: ${(p) => p.theme.colors.paleGrey};
    border: solid 1.5px ${(p) => p.theme.colors.silver};
  `,
  Title: styled(Typography)`
    font-size: 16px;
    color: ${(p) => p.theme.colors.marine};
    font-weight: bold;
    margin-bottom: 13px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 22px;
    }
  `,
  Row: styled.div`
    font-size: 14px;
    line-height: 22px;
    ${(p) => p.theme.breakpoints.up("md")} {
      font-size: 18px;
    }
  `,
  Key: styled(Typography)`
    display: inline;
    color: ${(p) => p.theme.colors.oceanBlue};
    &:after {
      content: ": ";
    }
  `,
  Value: styled(Typography)`
    display: inline;
    color: ${(p) => p.theme.colors.marine};
  `,
}

type WarrantyExtensionsProps = {
  data: WarrantyData[]
}

const WarrantyExtensions = ({ data }: WarrantyExtensionsProps) => (
  <>
    {data.map((item, i) => (
      <Styled.WarrantyExtension key={i}>
        <Container>
          <Styled.Title>תוצאות חיפוש</Styled.Title>
          <Styled.Row>
            <Styled.Key>מספר רישוי</Styled.Key>
            <Styled.Value>{item.licenseNumber}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>מספר שילדה</Styled.Key>
            <Styled.Value>{item.chassisNumber}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>רכיב</Styled.Key>
            <Styled.Value>{item.component}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>תיאור התופעה</Styled.Key>
            <Styled.Value>{item.phenomenonDesc}</Styled.Value>
          </Styled.Row>
          <Styled.Row>
            <Styled.Key>משך הארכת אחריות</Styled.Key>
            <Styled.Value>{item.extensionDuration}</Styled.Value>
          </Styled.Row>
        </Container>
      </Styled.WarrantyExtension>
    ))}
    {data.length === 0 && <EmptyResults />}
  </>
)

export default WarrantyExtensions
